import type { I18n, Locale } from 'vue-i18n';
import { createI18n } from 'vue-i18n';
import Cookies from 'js-cookie';
import zh from '@/summit/2023/locales/zh.yaml';
import en from '@/summit/2023/locales/en.yaml';

import { COOKIE_KEY_LANGUAGE } from '@/summit/2023/constants';

let i18n: I18n<NonNullable<unknown>, NonNullable<unknown>, NonNullable<unknown>, Locale, false>;

export const getInstance = () => {
  if (!i18n) {
    const language = Cookies.get(COOKIE_KEY_LANGUAGE);

    i18n = createI18n({
      legacy: false,
      locale: language || 'zh',
      fallbackLocale: 'zh',
      messages: {
        zh,
        en,
      },
    });
  }

  return i18n;
}
